import {
    FETCH_DELETE_COMMONS_CAPACITIES_REQUEST,
    FETCH_DELETE_COMMONS_CAPACITIES_SUCCESS,
    FETCH_DELETE_COMMONS_CAPACITIES_FAILURE,
} from '../../actions/commonsCapacities/delete-commonsCapacities-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteCommonCapacitiesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_COMMONS_CAPACITIES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_COMMONS_CAPACITIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_COMMONS_CAPACITIES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteCommonCapacitiesReducer;